import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Tooltip from 'components/Shared/Tooltip'
import ToggleButton from '../ToggleButton'

import './ToggleField.scss'
import Icon from '../../Icon'

const ToggleField = props => {
  let {
    name,
    boxed,
    label,
    inputValue,
    helpText,
    onChange,
    handleChange,
    onInputChange,
    value,
    hideLabelOnDisabled,
    hideInput,
    input,
    disabled,
    color,
    inverted,
    largeHelpText,
    tooltip,
  } = props

  if (input) {
    name = input.name
    onChange = input.onChange
    value = input.value
  }

  // Determine if the field should appear enabled or disabled
  // If inverted, value=false means Enabled(On), value=true means Disabled(Off)
  const isEnabled = inverted ? !value : value

  return (
    <div
      className={classNames('toggle-field', {
        'toggle-field-boxed': boxed,
        'toggle-field-enabled': isEnabled,
        'toggle-field-disabled': !isEnabled,
        'toggle-field-label-hidden': !isEnabled && hideLabelOnDisabled,
        'toggle-field-input-hidden': hideInput,
        'toggle-field-large-help-text': largeHelpText,
      })}
    >
      {label && (
        <label
          className={classNames('toggle-field-label', {
            'toggle-field-label-tooltip': tooltip,
          })}
        >
          {label}
          {tooltip && (
            <Tooltip tooltip={tooltip} placement={'top'}>
              <Icon className="select-tooltip" type="help-small" small />
            </Tooltip>
          )}
        </label>
      )}
      <div className={classNames('toggle-field-content')}>
        {!hideInput && (
          <input
            type="text"
            value={inputValue}
            onChange={onInputChange}
            disabled={!onInputChange}
          />
        )}
        <ToggleButton
          name={name}
          onChange={onChange || handleChange}
          value={!!value}
          disabled={disabled}
          color={color}
          inverted={inverted}
        />
      </div>
      {helpText && <span>{helpText}</span>}
    </div>
  )
}

ToggleField.propTypes = {
  label: PropTypes.string,
  helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  boxed: PropTypes.bool,
  hideLabelOnDisabled: PropTypes.bool,
  inputValue: PropTypes.string,
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
}

ToggleField.defaultProps = {
  boxed: false,
  hideLabelOnDisabled: false,
  disabled: false,
  tooltip: '',
}

export default ToggleField
